import React, { FC } from "react"
import styled from "styled-components"
import { getColor, getBg, color } from "../theme"

const mapSizes = {
  xsmall: "16px",
  small: "24px",
  normal: "32px",
  big: "48px",
}
export type SVGProps = {
  color?: ColorKeys
  hoverColor?: ColorKeys
  size?: IconSize
  onClick?: (event: React.MouseEvent) => void
}
export type IconProps = SVGProps & { name: IconKeys }

const Svg = styled.svg<SVGProps>`
  width: ${p => mapSizes[p.size || "normal"]};
  height: ${p => mapSizes[p.size || "normal"]};
  path,
  circle,
  line {
    transition: all 0.3s ease-out;
    fill: ${getColor};
  }
  &:hover {
    fill: ${p => (p.hoverColor ? color(p.hoverColor) : null)};
    path,
    circle,
    line {
      fill: ${p => (p.hoverColor ? color(p.hoverColor) : null)};
    }
  }
`

const Link: FC<SVGProps> = props => (
  <Svg
    width="32px"
    height="32px"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 48 48"
    {...props}
  >
    <path d="M0 24c0 13.26 10.74 24 24 24s24-10.74 24-24-10.74-24-24-24-24 10.74-24 24zM5 24c0-1.54 0.18-3.040 0.53-4.47l4.47 4.47-1 6 4 4v5.49c-4.84-3.44-8-9.099-8-15.49zM19.63 5.51c1.4-0.34 2.86-0.51 4.37-0.51 1.67 0 3.29 0.22 4.83 0.62l-0.83 1.38 1 1h3l0.83-0.83c0.699 0.37 1.359 0.77 2 1.22l-1.83 0.61-2 2 2 1v1h-2v2c0 0 1.38 1 3 1 1.59 0 0.88-2.19 2-3 1.13-0.81 2.5-0.63 2.5-0.63l0.65 0.17c1.22 1.61 2.189 3.41 2.85 5.36v0.1c0 0-1.41-1-4-1s-5 1-5 1-2.82 0.82-3 3c-0.311 3.75 1 5 1 5l5 3v9.73c-3.27 2.67-7.45 4.27-12 4.27-2.15 0-4.21-0.35-6.14-1.010l5.14-11.99-1-5c0 0-3.97-5-6-5s-3 3-3 3l-2-4 6-4 3-8-0.37-1.49z"></path>
  </Svg>
)
const Cross: FC<SVGProps> = props => (
  <Svg
    width="32px"
    height="32px"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 18 18"
    {...props}
  >
    {/* <line x1="0" x2="18" y1="0" y2="18" />
      <line x1="18" x2="0" y1="0" y2="18" /> */}
    <path d="M0,2 L2,0 L18,16 L16,18 Z" />
    <path d="M0,16 L2,18 L18,2 L16,0 Z" />
  </Svg>
)
const Bank: FC<SVGProps> = props => (
  <Svg
    width="32px"
    height="32px"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 19 19"
    {...props}
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-422.000000, -3294.000000)" fill="#FFF">
        <g transform="translate(-1.000000, 2874.000000)">
          <g transform="translate(402.000000, 400.000000)">
            <path d="M25.5,30 C25.7761424,30 26,30.2238576 26,30.5 L26,35.9991654 L29,35.9991654 L29,30.5 C29,30.2238576 29.2238576,30 29.5,30 L31.5,30 C31.7761424,30 32,30.2238576 32,30.5 L32,35.9991654 L35,35.9991654 L35,30.5 C35,30.2238576 35.2238576,30 35.5,30 L37.5,30 C37.7761424,30 38,30.2238576 38,30.5 L38,35.9991654 L39.5,36 C39.7761424,36 40,36.2238576 40,36.5 L40,38.5 C40,38.7761424 39.7761424,39 39.5,39 L21.5,39 C21.2238576,39 21,38.7761424 21,38.5 L21,36.5 C21,36.2238576 21.2238576,36 21.5,36 L23,35.9991654 L23,30.5 C23,30.2238576 23.2238576,30 23.5,30 L25.5,30 Z M31.4518932,20.8408457 L39.378185,27.0249793 C39.709723,27.2836634 39.904,27.6817202 39.904,28.1030057 L39.904,28.9991654 L21,29 L21,28.1030057 C21,27.6817202 21.194277,27.2836634 21.525815,27.0249793 L29.4521068,20.8408457 C30.0402172,20.3826053 30.8637828,20.3826053 31.4518932,20.8408457 Z"></path>
          </g>
        </g>
      </g>
    </g>
  </Svg>
)
const Card: FC<SVGProps> = props => (
  <Svg
    width="32px"
    height="32px"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 23 17"
    {...props}
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-787.000000, -2937.000000)" fill="#FFF">
        <g transform="translate(-1.000000, 2874.000000)">
          <g transform="translate(769.000000, 42.000000)">
            <path d="M40.5050618,21 L20.4939079,21 C19.6686526,21 19,21.6610149 19,22.4768438 L19,36.5231562 C19,37.3389851 19.6686526,38 20.4939079,38 L40.5050618,38 C41.3303171,38 42,37.3389851 42,36.5231562 L42,22.4768438 C42,21.6610149 41.3303171,21 40.5050618,21 L40.5050618,21 Z M28.0489608,34.6755737 L25.7565848,34.6755737 L23.4652392,34.6755737 C22.9449471,34.6755737 22.1732664,34.4565934 22.1732664,33.5898388 C22.1732664,32.1333653 24.4975811,32.5468816 24.4975811,31.0476305 C24.4975811,30.1218022 23.0016126,29.2682883 23.0016126,27.1202444 C23.0016126,25.3062728 24.2276474,24.2643341 25.7565848,24.2643341 C27.2865526,24.2643341 28.5115571,25.3062728 28.5115571,27.1202444 C28.5115571,29.2682883 27.0166189,30.1218022 27.0166189,31.0476305 C27.0166189,32.5468816 29.3409335,32.1333653 29.3409335,33.5898388 C29.3409335,34.4565934 28.5682225,34.6755737 28.0489608,34.6755737 L28.0489608,34.6755737 Z M38.700009,33.5755797 C38.700009,34.0267809 38.330138,34.3924271 37.8737233,34.3924271 L32.5935316,34.3924271 C32.137117,34.3924271 31.7662157,34.0267809 31.7662157,33.5755797 L31.7662157,33.363729 C31.7662157,32.9125277 32.137117,32.5468816 32.5935316,32.5468816 L37.8737233,32.5468816 C38.330138,32.5468816 38.700009,32.9125277 38.700009,33.363729 L38.700009,33.5755797 L38.700009,33.5755797 Z M38.700009,29.676712 C38.700009,30.1279132 38.330138,30.4935594 37.8737233,30.4935594 L32.5935316,30.4935594 C32.137117,30.4935594 31.7662157,30.1279132 31.7662157,29.676712 L31.7662157,29.4648613 C31.7662157,29.0136601 32.137117,28.6480139 32.5935316,28.6480139 L37.8737233,28.6480139 C38.330138,28.6480139 38.700009,29.0136601 38.700009,29.4648613 L38.700009,29.676712 L38.700009,29.676712 Z M38.700009,25.7676592 C38.700009,26.2188605 38.330138,26.5834881 37.8737233,26.5834881 L32.5935316,26.5834881 C32.137117,26.5834881 31.7662157,26.2188605 31.7662157,25.7676592 L31.7662157,25.55479 C31.7662157,25.1035888 32.137117,24.7379426 32.5935316,24.7379426 L37.8737233,24.7379426 C38.330138,24.7379426 38.700009,25.1035888 38.700009,25.55479 L38.700009,25.7676592 L38.700009,25.7676592 Z"></path>
          </g>
        </g>
      </g>
    </g>
  </Svg>
)
const Escrow: FC<SVGProps> = props => (
  <Svg
    width="32px"
    height="32px"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 25 13"
    {...props}
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-60.000000, -3298.000000)" fill="#FFF">
        <g transform="translate(-1.000000, 2874.000000)">
          <g transform="translate(44.000000, 400.000000)">
            <path d="M22.57,24.42225 C23.133,23.85925 24.045,23.85925 24.607,24.42225 C25.17,24.98425 25.19,25.91725 24.628,26.47925 L24.628,26.47925 L21.346,29.76125 C21.038,30.06825 21.038,30.56725 21.346,30.87525 L21.346,30.87525 L24.628,34.15725 C25.19,34.71925 25.17,35.65225 24.607,36.21425 C24.045,36.77725 23.133,36.77725 22.57,36.21425 L22.57,36.21425 L17.231,30.87525 C16.923,30.56725 16.923,30.06825 17.231,29.76125 L17.231,29.76125 Z M36.465,24.42225 L41.804,29.76125 C42.112,30.06825 42.112,30.56725 41.804,30.87525 L36.465,36.21425 C35.902,36.77725 34.99,36.77725 34.428,36.21425 C33.865,35.65225 33.845,34.71925 34.407,34.15725 L37.689,30.87525 C37.997,30.56725 37.997,30.06825 37.689,29.76125 L34.407,26.47925 C33.845,25.91725 33.865,24.98425 34.428,24.42225 C34.99,23.85925 35.902,23.85925 36.465,24.42225 Z M29.531,28.60625 C30.475,28.60625 31.241,29.37125 31.241,30.31625 C31.241,31.26125 30.475,32.02725 29.531,32.02725 C28.586,32.02725 27.82,31.26125 27.82,30.31625 C27.82,29.37125 28.586,28.60625 29.531,28.60625 Z M33.761,28.86325 C34.565,28.86325 35.216,29.51525 35.216,30.31825 C35.216,31.12125 34.565,31.77225 33.761,31.77225 C32.958,31.77225 32.307,31.12125 32.307,30.31825 C32.307,29.51525 32.958,28.86325 33.761,28.86325 Z M25.299,28.86325 C26.103,28.86325 26.754,29.51525 26.754,30.31825 C26.754,31.12125 26.103,31.77225 25.299,31.77225 C24.496,31.77225 23.845,31.12125 23.845,30.31825 C23.845,29.51525 24.496,28.86325 25.299,28.86325 Z"></path>
          </g>
        </g>
      </g>
    </g>
  </Svg>
)
const ExpandWindow: FC<SVGProps> = props => (
  <Svg
    width="32px"
    height="32px"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 14 14"
    {...props}
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-422.000000, -2938.000000)" fill="#FFF">
        <g transform="translate(-1.000000, 2874.000000)">
          <g transform="translate(400.000000, 42.000000)">
            <path d="M33.9212055,26.6462338 C34.1651746,26.4029555 34.5593521,26.4029555 34.8033213,26.6462338 L35.9361033,27.7812137 C36.3283674,28.1739071 37,27.8951905 37,27.339673 L37,22.9587467 C37,22.4290894 36.5713798,22 36.0423016,22 L31.6661655,22 C31.1112554,22 30.8328436,22.6723678 31.2260644,23.0650612 L32.3655436,24.2067456 C32.6095127,24.4500239 32.6095127,24.844633 32.3655436,25.0888691 L26.0787945,31.3537662 C25.8357821,31.5980023 25.4406479,31.5980023 25.1976355,31.3537662 L24.0638967,30.2197441 C23.6716326,29.8270507 23,30.1048095 23,30.6612848 L23,35.0422111 C23,35.5709106 23.4286202,36 23.9576984,36 L28.3338345,36 C28.8887446,36 29.1671564,35.32859 28.7748924,34.9349388 L27.6344564,33.7942122 C27.391444,33.5509338 27.391444,33.155367 27.6344564,32.9120887 L33.9212055,26.6462338"></path>
          </g>
        </g>
      </g>
    </g>
  </Svg>
)
const Expand: FC<SVGProps> = props => (
  <Svg
    width="32px"
    height="32px"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 20 20"
    {...props}
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-62.000000, -2935.000000)" fill="#FFF">
        <g transform="translate(-1.000000, 2874.000000)">
          <path d="M68.9717326,73.344364 C69.4322908,72.885212 70.1774637,72.885212 70.6380219,73.344364 L70.6380219,73.344364 L70.6545813,73.36091 C71.1151396,73.8210962 71.1151396,74.5667011 70.6545813,75.0258532 L70.6545813,75.0258532 L68.0133575,77.6649431 C67.7504771,77.9286453 67.7504771,78.3547053 68.0133575,78.6184074 L68.0133575,78.6184074 L69.2459976,79.8500517 C69.6713671,80.2740434 69.3701931,81 68.7699149,81 L68.7699149,81 L64.0359973,81 C63.4636631,81 63,80.5367115 63,79.9648397 L63,79.9648397 L63,75.2347466 C63,74.6349535 63.7265435,74.3340228 64.1508781,74.7590486 L64.1508781,74.7590486 L65.3773085,75.983454 C65.6401889,76.2471562 66.0676283,76.2471562 66.3305087,75.983454 L66.3305087,75.983454 Z M75.3619442,73.3454187 C75.8210962,72.8848604 76.5667011,72.8848604 77.0258532,73.3454187 L77.0258532,73.3454187 L79.6649431,75.9866425 C79.9286453,76.2495229 80.3557394,76.2495229 80.6184074,75.9866425 L80.6184074,75.9866425 L81.8500517,74.7529674 C82.2750776,74.3286329 83,74.6298069 83,75.2300851 L83,75.2300851 L83,79.9640027 C83,80.5363369 82.5367115,81 81.9648397,81 L81.9648397,81 L77.2357808,81 C76.6349535,81 76.3350569,80.2734565 76.7590486,79.8491219 L76.7590486,79.8491219 L77.983454,78.6226915 C78.2471562,78.3598111 78.2471562,77.9323717 77.983454,77.6694913 L77.983454,77.6694913 L75.344364,75.0282674 C74.885212,74.5677092 74.885212,73.8215013 75.344364,73.3619781 L75.344364,73.3619781 Z M68.7646945,61 C69.3654635,61 69.665331,61.725579 69.2413804,62.1509898 L69.2413804,62.1509898 L68.0160597,63.3765041 C67.7534171,63.63941 67.7534171,64.0668909 68.0160597,64.3297969 L68.0160597,64.3297969 L70.6548939,66.971277 C71.1150354,67.4318799 71.1150354,68.1781602 70.6548939,68.637728 L70.6548939,68.637728 L70.6383494,68.6553241 C70.1792419,69.114892 69.4337092,69.114892 68.9735677,68.6553241 L68.9735677,68.6553241 L66.3347336,66.013844 C66.072091,65.749903 65.6450383,65.749903 65.3823957,66.013844 L65.3823957,66.013844 L64.1508708,67.2466037 C63.7258862,67.6709794 63,67.3708112 63,66.7694398 L63,66.7694398 L63,62.0350628 C63,61.4637081 63.4642776,61 64.0350599,61 L64.0350599,61 Z M81.9640027,61 C82.5363369,61 83,61.4632436 83,62.0350599 L83,62.0350599 L83,66.7646945 C83,67.3644295 82.2734565,67.665331 81.8491219,67.2403464 L81.8491219,67.2403464 L80.6226915,66.0160597 C80.3598111,65.7534171 79.9323717,65.7534171 79.6694913,66.0160597 L79.6694913,66.0160597 L77.0282674,68.6548939 C76.5677092,69.1150354 75.8225363,69.1150354 75.3619781,68.6548939 L75.3619781,68.6548939 L75.3454187,68.6383494 C74.8848604,68.1782079 74.8848604,67.4337092 75.3454187,66.9735677 L75.3454187,66.9735677 L77.9866425,64.3347336 C78.2495229,64.071057 78.2495229,63.6450383 77.9866425,63.3813617 L77.9866425,63.3813617 L76.7529674,62.1498368 C76.3286329,61.7258862 76.6298069,61 77.2300851,61 L77.2300851,61 Z"></path>
        </g>
      </g>
    </g>
  </Svg>
)
const Star: FC<SVGProps> = props => (
  <Svg
    width="32px"
    height="32px"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 21 20"
    {...props}
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-781.000000, -3294.000000)" fill="#FFF">
        <g transform="translate(-1.000000, 2874.000000)">
          <g transform="translate(762.000000, 400.000000)">
            <path d="M31.4428797,20.6823678 L33.1475073,25.9125837 C33.3362303,26.4920246 33.8779163,26.8834013 34.4879506,26.8834013 L40.0068228,26.8834013 C40.9667598,26.8834013 41.3666485,28.107343 40.5893138,28.6695022 L36.1242299,31.9021721 C35.6304898,32.2600022 35.4244247,32.8943375 35.6131477,33.4727617 L37.3177753,38.7029777 C37.6146315,39.6128014 36.5700242,40.3691242 35.7937097,39.8069649 L31.3286258,36.574295 C30.8348856,36.2164649 30.1656841,36.2164649 29.671944,36.574295 L25.2068601,39.8069649 C24.4305455,40.3691242 23.3849181,39.6128014 23.6817743,38.7029777 L25.3874221,33.4727617 C25.5761451,32.8943375 25.3690598,32.2600022 24.8753197,31.9021721 L20.4102358,28.6695022 C19.6339212,28.107343 20.0327898,26.8834013 20.9927268,26.8834013 L26.511599,26.8834013 C27.1226534,26.8834013 27.6633193,26.4920246 27.8520423,25.9125837 L29.55769,20.6823678 C29.8545462,19.7725441 31.1460235,19.7725441 31.4428797,20.6823678"></path>
          </g>
        </g>
      </g>
    </g>
  </Svg>
)
const Sync: FC<SVGProps> = props => (
  <Svg
    width="32px"
    height="32px"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 16 20"
    {...props}
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-1140.000000, -2936.000000)" fill="#FFF">
        <g transform="translate(-1.000000, 2874.000000)">
          <g transform="translate(1119.000000, 42.000000)">
            <path d="M23.2506019,26.4968834 C23.6220287,25.9523929 24.3984687,25.84582 24.942767,26.2246382 L24.942767,26.2246382 L24.9635116,26.238202 C25.4959559,26.6083005 25.6391923,27.3252453 25.2796195,27.8590785 C24.9506697,28.3464071 24.7106253,28.8928353 24.58517,29.4760795 C23.9588812,32.3845501 25.9671542,34.9742708 28.7064268,35.3821543 C29.0966225,35.4393161 29.4502682,35.1389743 29.4502682,34.7524055 L29.4502682,34.7524055 L29.4502682,33.6440476 C29.4502682,33.3669582 29.7742788,33.2090365 29.9995057,33.3766466 L29.9995057,33.3766466 L33.7463723,36.1581985 C34.0852004,36.4091292 34.0842126,36.908084 33.7453844,37.1590147 L33.7453844,37.1590147 L29.9995057,39.931847 C29.773291,40.0984882 29.4502682,39.9405666 29.4502682,39.6634771 L29.4502682,39.6634771 L29.4502682,38.4621102 C29.4502682,38.1249524 29.178613,37.8623956 28.8368213,37.8342991 C25.0079643,37.5233001 22,34.3784316 22,30.5437459 C22,29.0459127 22.4623078,27.6556212 23.2506019,26.4968834 Z M30.0004943,20.068153 C30.226709,19.9015118 30.5497318,20.0594334 30.5497318,20.3365229 L30.5497318,20.3365229 L30.5497318,21.5378898 C30.5497318,21.8750476 30.821387,22.1376044 31.1631787,22.1657009 C34.9920357,22.4766999 38,25.6215684 38,29.4562541 C38,30.9540873 37.5376922,32.3443788 36.7493981,33.5031166 C36.3779713,34.0476071 35.6015313,34.15418 35.057233,33.7753618 L35.057233,33.7753618 L35.0364884,33.761798 C34.5040441,33.3916995 34.3608077,32.6747547 34.7203805,32.1409215 C35.0493303,31.6535929 35.2893747,31.1071647 35.41483,30.5239205 C36.0411188,27.6154499 34.0328458,25.0257292 31.2935732,24.6178457 C30.9033775,24.5606839 30.5497318,24.8610257 30.5497318,25.2475945 L30.5497318,25.2475945 L30.5497318,26.3559524 C30.5497318,26.6330418 30.2257212,26.7909635 30.0004943,26.6233534 L30.0004943,26.6233534 L26.2536277,23.8418015 C25.9147996,23.5908708 25.9157874,23.091916 26.2546156,22.8409853 L26.2546156,22.8409853 Z"></path>
          </g>
        </g>
      </g>
    </g>
  </Svg>
)
const Window: FC<SVGProps> = props => (
  <Svg
    width="32px"
    height="32px"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 22 22"
    {...props}
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-1139.000000, -3293.000000)" fill="#FFF">
        <g transform="translate(-1.000000, 2874.000000)">
          <g transform="translate(1120.000000, 400.000000)">
            <path d="M40.6153915,19 C41.380129,19 42,19.619871 42,20.3846085 L42,20.3846085 L42,39.616377 C42,40.380129 41.380129,41 40.6153915,41 L40.6153915,41 L36.5671923,41 L29,40.9999997 L21.383623,41 C20.6188855,41 20,40.380129 20,39.616377 L20,39.616377 L20,20.3846085 C20,19.619871 20.6188855,19 21.383623,19 L21.383623,19 Z M39.3177388,25 L22.6822612,25 C22.3050682,25 22,25.3081178 22,25.6868867 L22,25.6868867 L22,38.3131133 C22,38.6918822 22.3050682,39 22.6822612,39 L22.6822612,39 L39.3177388,39 C39.6949318,39 40,38.6918822 40,38.3131133 L40,38.3131133 L40,25.6868867 C40,25.3081178 39.6949318,25 39.3177388,25 L39.3177388,25 Z M31,23 C30.4468571,23 30,22.5531429 30,22 C30,21.448 30.4468571,21 31,21 C31.552,21 32,21.448 32,22 C32,22.5531429 31.552,23 31,23 L31,23 Z M39,23 C38.4468571,23 38,22.5531429 38,22 C38,21.448 38.4468571,21 39,21 C39.552,21 40,21.448 40,22 C40,22.5531429 39.552,23 39,23 L39,23 Z M35,23 C34.4468571,23 34,22.5531429 34,22 C34,21.448 34.4468571,21 35,21 C35.552,21 36,21.448 36,22 C36,22.5531429 35.552,23 35,23 L35,23 Z"></path>
          </g>
        </g>
      </g>
    </g>
  </Svg>
)
const Play: FC<SVGProps> = props => (
  <Svg
    width="32px"
    height="32px"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M10.396 18.433c2.641-2.574 6.604-6.433 6.604-6.433s-3.963-3.859-6.604-6.433c-0.363-0.349-0.853-0.567-1.396-0.567-1.104 0-2 0.896-2 2v10c0 1.104 0.896 2 2 2 0.543 0 1.033-0.218 1.396-0.567z"></path>
  </Svg>
)

const Linkedin: FC<SVGProps> = props => (
  <Svg
    width="32px"
    height="32px"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 32 32"
    {...props}
  >
    <path d="M12 12h5.535v2.837h0.079c0.77-1.381 2.655-2.837 5.464-2.837 5.842 0 6.922 3.637 6.922 8.367v9.633h-5.769v-8.54c0-2.037-0.042-4.657-3.001-4.657-3.005 0-3.463 2.218-3.463 4.509v8.688h-5.767v-18z"></path>
    <path d="M2 12h6v18h-6v-18z"></path>
    <path d="M8 7c0 1.657-1.343 3-3 3s-3-1.343-3-3c0-1.657 1.343-3 3-3s3 1.343 3 3z"></path>
  </Svg>
)
const Facebook: FC<SVGProps> = props => (
  <Svg
    width="32px"
    height="32px"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 32 32"
    {...props}
  >
    <path d="M19 6h5v-6h-5c-3.86 0-7 3.14-7 7v3h-4v6h4v16h6v-16h5l1-6h-6v-3c0-0.542 0.458-1 1-1z"></path>
  </Svg>
)

const Menu: FC<SVGProps> = props => (
  <Svg
    width="32px"
    height="32px"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 24 26"
    {...props}
  >
    <path d="M19 17h-14c-1.103 0-2 0.897-2 2s0.897 2 2 2h14c1.103 0 2-0.897 2-2s-0.897-2-2-2z"></path>
    <path d="M19 10h-14c-1.103 0-2 0.897-2 2s0.897 2 2 2h14c1.103 0 2-0.897 2-2s-0.897-2-2-2z"></path>
    <path d="M19 3h-14c-1.103 0-2 0.897-2 2s0.897 2 2 2h14c1.103 0 2-0.897 2-2s-0.897-2-2-2z"></path>
  </Svg>
)

const Twitter: FC<SVGProps> = props => (
  <Svg
    width="32px"
    height="32px"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 32 32"
    {...props}
  >
    <path d="M32 7.075c-1.175 0.525-2.444 0.875-3.769 1.031 1.356-0.813 2.394-2.1 2.887-3.631-1.269 0.75-2.675 1.3-4.169 1.594-1.2-1.275-2.906-2.069-4.794-2.069-3.625 0-6.563 2.938-6.563 6.563 0 0.512 0.056 1.012 0.169 1.494-5.456-0.275-10.294-2.888-13.531-6.862-0.563 0.969-0.887 2.1-0.887 3.3 0 2.275 1.156 4.287 2.919 5.463-1.075-0.031-2.087-0.331-2.975-0.819 0 0.025 0 0.056 0 0.081 0 3.181 2.263 5.838 5.269 6.437-0.55 0.15-1.131 0.231-1.731 0.231-0.425 0-0.831-0.044-1.237-0.119 0.838 2.606 3.263 4.506 6.131 4.563-2.25 1.762-5.075 2.813-8.156 2.813-0.531 0-1.050-0.031-1.569-0.094 2.913 1.869 6.362 2.95 10.069 2.95 12.075 0 18.681-10.006 18.681-18.681 0-0.287-0.006-0.569-0.019-0.85 1.281-0.919 2.394-2.075 3.275-3.394z"></path>
  </Svg>
)

const Youtube: FC<SVGProps> = props => (
  <Svg
    width="32px"
    height="32px"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 32 32"
    {...props}
  >
    <path d="M31.681 9.6c0 0-0.313-2.206-1.275-3.175-1.219-1.275-2.581-1.281-3.206-1.356-4.475-0.325-11.194-0.325-11.194-0.325h-0.012c0 0-6.719 0-11.194 0.325-0.625 0.075-1.987 0.081-3.206 1.356-0.963 0.969-1.269 3.175-1.269 3.175s-0.319 2.588-0.319 5.181v2.425c0 2.587 0.319 5.181 0.319 5.181s0.313 2.206 1.269 3.175c1.219 1.275 2.819 1.231 3.531 1.369 2.563 0.244 10.881 0.319 10.881 0.319s6.725-0.012 11.2-0.331c0.625-0.075 1.988-0.081 3.206-1.356 0.962-0.969 1.275-3.175 1.275-3.175s0.319-2.587 0.319-5.181v-2.425c-0.006-2.588-0.325-5.181-0.325-5.181zM12.694 20.15v-8.994l8.644 4.513-8.644 4.481z"></path>
  </Svg>
)

const ArrowUp: FC<SVGProps> = props => (
  <Svg
    width="32px"
    height="32px"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 22 30"
    {...props}
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g fill="#FFFFFF" fillRule="nonzero">
        <g transform="translate(11.000000, 15.000000) rotate(-180.000000) translate(-11.000000, -15.000000) ">
          <path d="M15.8453774,0 L15.8452536,16.0665968 L21.0003588,16.0672626 C21.5524433,16.0672626 22,16.5240028 22,17.0874288 C22,17.3311604 21.9144933,17.566842 21.7589563,17.7518053 L11.7585593,29.6441921 C11.3990179,30.0717557 10.7679179,30.120913 10.3489582,29.753988 C10.3104146,29.7202316 10.2744481,29.6835264 10.241371,29.6441913 L0.241060799,17.7518805 C-0.118480147,17.3243165 -0.070311336,16.6802562 0.34864885,16.3133317 C0.529888067,16.1546028 0.760823728,16.0672626 0.999651596,16.0672626 L5.84887885,16.0665968 L5.84900271,0 L15.8453774,0 Z"></path>
        </g>
      </g>
    </g>
  </Svg>
)
const ArrowDown: FC<SVGProps> = styled(ArrowUp)`
  transform: rotate(180deg);
`
const Check: FC<SVGProps> = props => (
  <Svg
    width="32px"
    height="32px"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 28 28"
    {...props}
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g>
        <g>
          <circle fill="#00BA74" cx="14" cy="14" r="14"></circle>
          <polygon
            fill="#FFFFFF"
            fillRule="nonzero"
            points="8.03835343 12.8321235 5.91703308 14.9534439 11.8682887 20.9046995 22.0294977 9.17293941 19.7618263 7.20884512 11.7106586 16.5044288"
          ></polygon>
        </g>
      </g>
    </g>
  </Svg>
)
const Lock: FC<SVGProps> = props => (
  <Svg
    width="32px"
    height="32px"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 24 27"
    {...props}
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g fill="#FFFFFF">
        <g>
          <path d="M12,0 C15.8659932,0 19,3.13400675 19,7 L19,11 L22,11 C23.1045695,11 24,11.8954305 24,13 L24,25 C24,26.1045695 23.1045695,27 22,27 L2,27 C0.8954305,27 0,26.1045695 0,25 L0,13 C0,11.8954305 0.8954305,11 2,11 L5,11 L5,7 C5,3.13400675 8.13400675,0 12,0 Z M12,3 C9.790861,3 8,4.790861 8,7 L8,11 L16,11 L16,7 C16,4.790861 14.209139,3 12,3 Z"></path>
        </g>
      </g>
    </g>
  </Svg>
)

const Icon: FC<IconProps> = ({ name, ...props }) => {
  switch (name) {
    case "arrow-down":
      return <ArrowDown {...props} />
    case "arrow-up":
      return <ArrowUp {...props} />
    case "check":
      return <Check {...props} />
    case "lock":
      return <Lock {...props} />
    case "linkedin":
      return <Linkedin {...props} />
    case "facebook":
      return <Facebook {...props} />
    case "menu":
      return <Menu {...props} />
    case "twitter":
      return <Twitter {...props} />
    case "youtube":
      return <Youtube {...props} />
    case "play":
      return <Play {...props} />
    case "bank":
      return <Bank {...props} />
    case "card":
      return <Card {...props} />
    case "escrow":
      return <Escrow {...props} />
    case "expand-window":
      return <ExpandWindow {...props} />
    case "expand":
      return <Expand {...props} />
    case "star":
      return <Star {...props} />
    case "sync":
      return <Sync {...props} />
    case "window":
      return <Window {...props} />
    case "cross":
      return <Cross {...props} />
    case "link":
      return <Link {...props} />
    default:
      return null
  }
}

const Square = styled.div<{ bg?: ColorKeys }>`
  display: grid;
  justify-items: center;
  align-items: center;
  width: 60px;
  height: 60px;
  background-color: ${getBg};
`
export const SquareIcon: React.FC<{ bg?: ColorKeys } & IconProps> = ({
  bg,
  ...props
}) => (
  <Square bg={bg}>
    <Icon {...props} />
  </Square>
)

const ButtonIconContainer = styled.div<{ bg?: ColorKeys }>`
  display: grid;
  justify-items: center;
  align-items: center;
  background-color: ${getBg};
`

export const ButtonIcon: React.FC<{ bg?: ColorKeys } & IconProps> = ({
  bg,
  name,
  ...props
}) => (
  <ButtonIconContainer bg={bg} {...props}>
    <Icon name={name} />
  </ButtonIconContainer>
)

export default Icon
